export default {
	field: 'reasonDisplay',
	name: 'Reason',
	width: '200px',
}
